/**
 * Läuft die Anwendung vom Home-Bildschirm oder im Browser?
 *
 * **Gebraucht wird das für genau eine Sache, und die ist unangenehm:**
 * `window.print()` ist in einer vom Home-Bildschirm gestarteten Web-App auf
 * iOS nicht verlässlich — die Druckvorschau bleibt dort hängen. Im Browser
 * funktioniert derselbe Aufruf. Gemeldet vom iPhone am Buch (#14): „der Button
 * zum Drucken funktioniert auch nicht."
 *
 * Zwei Wege, weil ein Weg nicht reicht: `display-mode` ist der standardisierte
 * und greift auf Android und am Rechner; `navigator.standalone` ist Apples
 * älterer und der einzige, auf den auf dem iPhone Verlass ist.
 *
 * **Kein Rückschluss auf das Betriebssystem.** Gefragt wird, wie die Anwendung
 * gestartet wurde, nicht auf welchem Gerät — eine Kennung auszuwerten wäre
 * dieselbe Rateaufgabe in schlechter.
 */
export function alsApp(): boolean {
  if (typeof window === 'undefined') return false
  const standalone = (window.navigator as { standalone?: boolean }).standalone === true
  return window.matchMedia('(display-mode: standalone)').matches || standalone
}
